import reducer from "./reducer";
export { default as IssueLicences } from "./components";
export { default as issueLicencesReducerName } from "./constants";
export default reducer;
